<template>
  <klereo-alert v-if="!token">
    <Translation keypath="BlePublicAlert">
      <template #connectionLink>
        <a @click="router.push('/')"> {{ $t("ConnectionLink") }}</a></template
      >
      <template #createAccountLink>
        <a
          @click="
            browse({ url: config.externalLinksRoot + '/v1/?page=register' })
          "
        >
          {{ $t("CreateAccountLink") }}</a
        ></template
      >
    </Translation>
  </klereo-alert>
</template>

<script setup lang="ts">
import { Translation } from "vue-i18n";
import KlereoAlert from "@/shared/components/KlereoAlert.vue";
import { useBrowse } from "@/shared/mixins/useLink.ts";
import { useRouter } from "vue-router";
import config from "@/config";

const browse = useBrowse();
const router = useRouter();

const token = localStorage.getItem("token");
</script>
